import { FC } from 'react';

import { BillingInfoForm } from '../BillingInfoForm';
import { CheckoutFormValues } from '../types';

export const CheckoutWizard: FC<CheckoutFormValues> = ({ children, submitAction }) => {
  return <BillingInfoForm submitAction={submitAction}>{children}</BillingInfoForm>;
};
